import axios from "axios";

import { TTP_API_URL } from "../config";
import { getRequestConfig, throwCatchedError } from "../utils";

let getServicesCTS;

export const saveRate = async (token, data) => {
  const requestUrl = `${TTP_API_URL}/organization/ua-rate`;

  var formData = new FormData();
  formData.append("access_token", token);
  formData.append("type", data.type);
  formData.append("nbFrom", data.nbFrom);
  formData.append("nbTo", data.nbTo);
  formData.append("monthPrice", data.monthPrice);
  formData.append("annualPrice", data.annualPrice);
  formData.append("status", data.status);

  if (data.app) {
    formData.append("app", data.app);
  }

  if (data.appOtpion) {
    formData.append("appOtpion", data.appOtpion);
  }

  if (data.id) {
    formData.append("id", data.id);
  }

  let requestConfig = getRequestConfig();
  return await axios.post(requestUrl, formData, requestConfig);
};

export const getRates = (token) => {
  const requestUrl = `${TTP_API_URL}/organization/ua-rate`;

  const sort = [
    {
      property: "nbFrom",
      dir: "desc",
    },
  ];
  const params = {
    access_token: token,
    sort: JSON.stringify(sort),
    limit: 200,
  };
  let requestConfig = getRequestConfig(params);

  return axios.get(requestUrl, requestConfig).catch(function (thrown) {
    throwCatchedError(thrown);
  });
};

export const deleteRate = (token, id) => {
  const requestUrl = `${TTP_API_URL}/organization/ua-rate/${id}`;
  var formData = new FormData();

  formData.append("access_token", token);
  formData.append("_method", "delete");

  let requestConfig = getRequestConfig();

  return axios.post(requestUrl, formData, requestConfig);
};
